module.exports = __webpack_public_path__ + "player.png?4612777a446ad6f5ac238f4a18bf2df7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/player.png
// module id = 71
// module chunks = 0